import { Button, Typography } from "@mui/material";
import CustomDialog from "../../../commons/dialog/customDialog";
import { StyledDialog } from "../../../styled/dialog";
import { StyledFormHeader, StyledFpaConfirmDialog } from "../../../styled/form";

const FpaConfirmDialog = ({
  open,
  title,
  text,
  handleConfirmarYFinalizar,
  handleConfirmarYContinuar,
}) => {
  return (
    <CustomDialog open={open}>
      <StyledFpaConfirmDialog.TitleContainer>
        <Typography sx={StyledFormHeader.text}>{title}</Typography>
      </StyledFpaConfirmDialog.TitleContainer>
      <StyledFpaConfirmDialog.ContentContainer>
        <Typography sx={{ padding: "20px 0 0 0" }} >{text}</Typography>
      </StyledFpaConfirmDialog.ContentContainer>
      <StyledDialog.Actions>
        <Button
          variant="contained"
          color="secondary"
          type="button"
          onClick={handleConfirmarYFinalizar}>
          Guardar y Finalizar
        </Button>
        <Button
          color="primary"
          variant="contained"
          type="button"
          onClick={handleConfirmarYContinuar}>
          Guardar y Continuar
        </Button>
      </StyledDialog.Actions>
    </CustomDialog>
  );
};

export default FpaConfirmDialog;
